import { useTranslation } from '@eti/providers';
import { css, etiColors } from '@eti/styles';
import PropTypes from 'prop-types';

const segmentInfoStyles = css`
  color: ${etiColors.grayScale[10]};
  font-size: 0.625rem;
`;

const TripDetailsSegmentInfo = ({
  flight,
  marketingCarrier = {},
  operatingCarrier = {},
  operatingInformation,
  ...rest
}) => {
  const { t } = useTranslation();

  const operatedBy =
    operatingInformation ||
    (operatingCarrier.code !== marketingCarrier.code ? operatingCarrier.name : null);

  return (
    <div className={segmentInfoStyles} {...rest}>
      <div>{flight}</div>

      {operatedBy && (
        <div>
          {t('TripDetails.OperatingCarrier')} {operatedBy}
        </div>
      )}
    </div>
  );
};

TripDetailsSegmentInfo.propTypes = {
  flight: PropTypes.string,
  marketingCarrier: PropTypes.shape({
    code: PropTypes.string,
    name: PropTypes.string,
  }),
  operatingCarrier: PropTypes.shape({
    code: PropTypes.string,
    name: PropTypes.string,
  }),
  operatingInformation: PropTypes.string,
};

export default TripDetailsSegmentInfo;
